import { useState } from "react";
import { NEWS } from "../../../mocks/newsData";

type Props = {
  onOpen: (id: string) => void;
};

const FEATURE_IDS = ["n13", "n06", "n01"];
const ACCENTS = ["border-accent-400", "border-secondary-400", "border-primary-400"];

export default function DepthSection({ onOpen }: Props) {
  const [picked, setPicked] = useState(FEATURE_IDS);
  const features = picked.map((id) => NEWS.find((n) => n.id === id)).filter(Boolean);

  return (
    <section className="mx-auto max-w-[1440px] px-4 py-10 md:px-6 md:py-14" id="depth">
      <div className="flex items-end justify-between border-b-2 border-foreground-950 pb-3">
        <div>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">深度追踪</h2>
          <p className="mt-1 text-sm text-foreground-500">不止于快，把事件背后的逻辑一次讲透</p>
        </div>
        <span className="hidden font-label text-xs uppercase tracking-widest text-foreground-400 sm:block">
          Long-read · 本期 {features.length} 篇
        </span>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {features.map((item, index) => {
          if (!item) return null;
          return (
            <article
              key={item.id}
              className={`group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-100/60 ${ACCENTS[index % ACCENTS.length]} border-t-4 transition-transform hover:-translate-y-0.5`}
              onClick={() => onOpen(item.id)}
            >
              <div className="relative h-40 overflow-hidden rounded-t-lg md:h-48">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-sm bg-background-950/70 px-2 py-0.5 font-label text-[11px] font-bold uppercase tracking-widest text-background-50">
                  特稿 0{index + 1}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <div className="flex items-center gap-2 text-[11px] text-foreground-500">
                  <span className="font-medium text-primary-600">{item.badge}</span>
                  <span>{item.author}</span>
                  <span className="ml-auto flex items-center gap-1">
                    <i className="ri-time-line" aria-hidden="true" /> {item.readMin} 分钟
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {item.title}
                </h3>
                <p className="mt-2 line-clamp-3 flex-1 text-sm leading-6 text-foreground-600">{item.excerpt}</p>
                <span className="mt-3 flex items-center gap-1 text-xs font-medium text-primary-600">
                  阅读全文
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </span>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}